<template>
  <div class="question">
    <template v-if="step === 1">
      <div class="title">1.Which of these best describes you?</div>
      <div class="list">
        <el-radio-group v-model="question1" @input="e => selectQuestion(1, e)">
          <div class="item f--c">
            <el-radio :label="1">I’m using KakaClo as my start of business</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="3">I’m already selling online and in person before using KakaClo</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="4">I’m already selling online before using KakaClo</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="5">I’m already selling in person before using KakaClo</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="2">I'm just using KakaClo for shopping</el-radio>
          </div>
        </el-radio-group>
      </div>
    </template>
    <template v-if="step === 2">
      <div class="title">2.How would you describe your store type?</div>
      <div class="list">
        <el-radio-group v-model="question2" @input="e => selectQuestion(2, e)">
          <div class="item f--c">
            <el-radio :label="1">FASHION RELATED STORE: a store that has a bunch of fashion related products</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="2">ONE-PRODUCT STORE: a store that only focuses on selling one or two main products, such as a dress store, lingerie store, etc</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="3">GENERAL STORE: a store that has a bunch of products all around it</el-radio>
          </div>
        </el-radio-group>
      </div>
    </template>
    <template v-if="step === 3">
      <div class="title">3.What is your store annual revenues?</div>
      <div class="list">
        <el-radio-group v-model="question3" @input="e => selectQuestion(3, e)">
          <div class="item f--c">
            <el-radio :label="1">Below $50,000</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="2">In the range from $50,000 to $100,000</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="3">In the range from $100,000 to $200,000</el-radio>
          </div>
          <div class="item f--c">
            <el-radio :label="4">Over $200,000</el-radio>
          </div>
        </el-radio-group>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      require: true,
      default: 1
    }
  },
  data() {
    return {
      question1: -1,
      question2: -1,
      question3: -1
    }
  },
  methods: {
    selectQuestion(type, e) {
      this.$emit('selectQuestion', type, e)
    }
  }
}
</script>

<style lang="scss" scoped>
.question {
  width: 100%;

  .title {
    font-size: 16px;
    color: #303133;
    padding-left: 10px;
  }

  .list {
    margin-top: 20px;
    height: 280px;
    .item {
      margin-bottom: 16px;

      /deep/ .el-radio{
        width: 100%;
        display: flex;
        .el-radio__input {
          position: relative;
          top: 3.6px;
        }
        .el-radio__label {
          line-height: 22px;
          text-overflow: ellipsis;
          white-space: normal;
        }
      }
    }
  }
}
</style>
